import React from "react";
//#region types
import { ExportItemTypeProps } from "models/propTypes/revisorPropTypes";
import { TranslationKeys } from "translations";
//#endregion
import EmptyFolderMessage from "./emptyFolderMessage";
//#region components
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useExportAttachmentsHelper() {
  const getExportAttachmentTypes = (
    previousPeriod: string,
    currentPeriod: string,
    isAutoAnnualReport?: boolean,
    sharedDocuments?: string[]
  ): ExportItemTypeProps[] => {
    const reconciliationReportExport: ExportItemTypeProps = {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.FinancialStatementAttachments),
      statusLabelText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportedAsSoonAsPossible),
      isDownloadAvailable: false,
      exportItems: [
        {
          itemText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.BalanceAccounts),
          itemSubtext: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.All),
          isDownloadAvailable: false,
        },
      ],
    };

    const sieFilesExport: ExportItemTypeProps = {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.SIEFiles),
      statusLabelText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.ExportedAsSoonAsPossible),
      isDownloadAvailable: false,
      exportItems: [
        {
          itemText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Period),
          itemSubtext: previousPeriod,
          isDownloadAvailable: false,
        },
        {
          itemText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Period),
          itemSubtext: currentPeriod,
          isDownloadAvailable: false,
        },
      ],
    };

    const taxCalculationReportExport: ExportItemTypeProps = {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.TaxCalculationReport),
      statusLabelText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.DownloadedDirectly),
      isDownloadAvailable: true,
      exportItems: [
        {
          itemText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Period),
          itemSubtext: previousPeriod,
          isDownloadAvailable: true,
        },
      ],
    };

    const otherDocumentsExport: ExportItemTypeProps = {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.OtherDocuments),
      statusLabelText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.DownloadedDirectly),
      isDownloadAvailable: true,
      displayLoading: sharedDocuments === undefined,
      exportItems:
        sharedDocuments?.map((documentTitle) => ({
          itemText: documentTitle,
          isDownloadAvailable: true,
        })) ?? [],
      emptyListPlaceholder: React.createElement(EmptyFolderMessage),
    };

    const annualReportExport: ExportItemTypeProps = {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.AnnualReport),
      statusLabelText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Revisor.DownloadedDirectly),
      isDownloadAvailable: true,
      exportItems: [
        {
          itemText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.FinancialYear2),
          itemSubtext: previousPeriod,
          isDownloadAvailable: true,
        },
      ],
    };

    // Maintain the order of the export attachment types. The order is important for the UI.
    const exportAttachmentTypes = [reconciliationReportExport];
    if (isAutoAnnualReport) {
      exportAttachmentTypes.push(sieFilesExport);
      exportAttachmentTypes.push(taxCalculationReportExport);
      exportAttachmentTypes.push(annualReportExport);
    }
    exportAttachmentTypes.push(otherDocumentsExport);

    return exportAttachmentTypes;
  };

  return { getExportAttachmentTypes };
}

export default useExportAttachmentsHelper;
